var render = function render(){var _vm=this,_c=_vm._self._c;return _c('view-wrapper',{staticClass:"contact",attrs:{"header-text":"Connect with us"}},[_c('p',[_vm._v("The team behind "),_c('strong',[_vm._v("THE WEST IS BURNING")]),_vm._v(" are eager to hear what you have to say. Send us a note and we'll get back to you right away.")]),_c('contact-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }